'use client';

import React from 'react';
import AppLink from '@/componentv2/AppLink/AppLink';
import { scrollToTop } from '@/util';
import './footerColumn.scss';

export interface FooterLink {
  label: string;
  href?: string;
}

interface FooterColumnProps {
  title: string;
  links: FooterLink[];
}

function isExternalHref(href: string): boolean {
  return (
    href.startsWith('http://') ||
    href.startsWith('https://') ||
    href.startsWith('//')
  );
}

const FooterColumn: React.FC<FooterColumnProps> = ({ title, links }) => {
  return (
    <div className="footer-column">
      <h3 className="footer-column__title">{title}</h3>
      <ul className="footer-column__list">
        {links.map((link, index) => {
          const href = link.href || '';

          return (
            <li key={index} className="footer-column__item">
              {isExternalHref(href) ? (
                <a href={href} className="footer-column__link">
                  {link.label}
                </a>
              ) : (
                <AppLink
                  href={href}
                  intent="navigation"
                  className="footer-column__link"
                  onClick={scrollToTop}
                >
                  {link.label}
                </AppLink>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default FooterColumn;
